import { withParams } from 'vuelidate';
export default withParams({ type: 'accountNumberLength' }, (value) => {
	if (typeof value === 'undefined' || value === null || value === '') {
		return true;
	}
	const valueLength = value.replace(/\D/g, '').length;
	return valueLength == 13 || valueLength == 21;
});
